export default function SIncomingCall({ size = 20, className = "", ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path d="M1 31.1201V13.2623H6.95259V21.0007L26.9533 1L31.1201 5.16681L11.1194 25.1675H18.8578V31.1201H1Z" fill="currentColor"/>
        </svg>

    )
}